import { StaticCurrencyConfig } from '@/config/currency';
import { StaticInstrumentConfig } from '@/config/instruments';
import { CurrencyConfigResponse, InstrumentConfigResponse } from '@/types/sso';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { PURGE } from 'redux-persist';
import { RootState } from '../store';

export type InstrumentConfig = InstrumentConfigResponse & StaticInstrumentConfig;
export type CurrencyConfig = CurrencyConfigResponse & StaticCurrencyConfig;

export type InstrumentConfigs = {
    Margin: Record<string, InstrumentConfig>;
    Deliverable: Record<string, InstrumentConfig>;
};
export type CurrencyConfigs = CurrencyConfig[];

export interface OhoState {
    instrumentConfigs: InstrumentConfigs;
    currencyConfigs: CurrencyConfigs;
}

export const defaultOpenPositionState: OhoState = {
    instrumentConfigs: {
        Margin: {},
        Deliverable: {}
    },
    currencyConfigs: []
};

const initialState: OhoState = defaultOpenPositionState;

export const ohoSlice = createSlice({
    name: 'oho',
    initialState,
    reducers: {
        setInstrumentConfigs: (state, action: PayloadAction<InstrumentConfigs>) => {
            state.instrumentConfigs = action.payload;
        },
        setCurrencyConfigs: (state, action: PayloadAction<CurrencyConfigs>) => {
            state.currencyConfigs = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(PURGE, () => initialState);
    }
});

export const { setInstrumentConfigs, setCurrencyConfigs } = ohoSlice.actions;
export const selectInstrumentConfigs = (state: RootState) => state.oho.instrumentConfigs;
export const selectCurrencyConfigs = (state: RootState) => state.oho.currencyConfigs;
export const selectCurrencyConfigDict = (state: RootState) => {
    return state.oho.currencyConfigs.reduce((acc, curr) => {
        if (curr.celer !== curr.show) acc[curr.show] = curr;
        acc[curr.celer] = curr;

        return acc;
    }, {});
};

export default ohoSlice.reducer;
